<template>
  <div class="container-wrapper" v-loading="loading">
    <div class="breadcrumb-wrapper">
      <span>动态管理 / 新增</span>
      <el-button class="back" type="primary" @click="$router.go(-1)"
        >返回</el-button
      >
    </div>

    <div style="padding: 10px 20px">
      <el-form
        label-width="96px"
        label-position="left"
        :model="paramData"
        :rules="formRules"
        ref="formRef"
      >
        <el-form-item label="发布账号" prop="publishUid">
          <div class="form-item-row">
            <div class="form-item-row__col form-item-row__col--author">
              <el-select
                v-model="paramData.publishAuthorType"
                style="width: 100%"
                @change="onPublishAuthorTypeChange"
              >
                <el-option label="马甲号" :value="2"></el-option>
                <el-option label="官号" :value="3"></el-option>
                <el-option label="校园主理人" :value="4"></el-option>
              </el-select>
            </div>
            <div class="form-item-row__col form-item-row__col--mode">
              <el-select
                v-model="accountSearchMode"
                style="width: 100%"
                @change="onAccountSearchModeChange"
              >
                <el-option label="昵称" value="name"></el-option>
                <el-option label="用户ID" value="uid"></el-option>
              </el-select>
            </div>
            <div class="form-item-row__col form-item-row__col--grow">
              <el-select
                style="width: 100%"
                clearable
                filterable
                remote
                placeholder="选择用户ID或昵称"
                :loading="selectLoading"
                :remote-method="queryBurnerAccount"
                v-model="paramData.publishUid"
                @change="onPublishUserChange"
                @clear="onAccountSelectClear"
              >
                <el-option
                  v-for="item in accountOptions"
                  :key="item.uid"
                  :label="item.nickName"
                  :value="item.uid"
                >
                  <div class="account-option">
                    <img
                      v-if="item.headImgUrl"
                      class="account-option-avatar"
                      :src="item.headImgUrl"
                      alt=""
                    />
                    <span>{{ item.nickName }}（ID: {{ item.uid }}）</span>
                  </div>
                </el-option>
              </el-select>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="话题">
          <div class="form-item-row">
            <div class="form-item-row__col form-item-row__col--half">
              <el-select
                v-model="paramData.categoryId"
                style="width: 100%"
                clearable
                placeholder="话题分类"
                @change="changeTopicCategory"
              >
                <el-option
                  v-for="(item, index) in topicCategories"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
            <div class="form-item-row__col form-item-row__col--half">
              <el-select
                v-model="paramData.topicIds"
                multiple
                style="width: 100%"
                clearable
                placeholder="请选择话题（选填）"
                :disabled="!paramData.categoryId"
              >
                <el-option
                  v-for="(item, index) in topicList"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="动态内容" prop="content">
          <el-input
            type="textarea"
            :rows="4"
            :maxlength="500"
            placeholder="请输入内容"
            v-model="paramData.content"
            show-word-limit
          >
          </el-input>
        </el-form-item>
        <el-form-item label="素材">
          <el-select
            style="width: 100%"
            placeholder="请选择素材类型（选填）"
            v-model="paramData.type"
            clearable
            @change="onMaterialTypeChange"
          >
            <el-option label="图片" :value="1"></el-option>
            <el-option label="视频" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="paramData.type === 1" prop="fids">
          <div class="flex-row image-list">
            <SUpload
              :limit="9"
              v-model="paramData.fids"
              actionUrl="/adminapi/v1/basicTools/v650/file/upload?uploadImageType=6&fileType=1"
              :headers="uploadAuthHeaders"
              accept="image/*"
              type="drag"
              :show-file-list="false"
            />
            <!-- :size="300" -->
            <!-- <div
              class="image-bezel"
              v-for="(item, index) in paramData.fids"
              :key="index"
            >
              <UploadItem
                uploadImageType="6"
                fileType="1"
                :keys="`${item.fid}`"
                :urls="item.url"
                @onUrls="imageUploaded"
              >
              </UploadItem>
            </div> -->
          </div>
        </el-form-item>
        <el-form-item v-if="paramData.type === 2" prop="fids">
          <div
            class="video-material-wrap"
            v-loading="videoProcessing"
            element-loading-text="正在上传视频、生成封面并读取时长…"
          >
            <UploadItem
              uploadImageType="6"
              fileType="3"
              :keys="`${paramData.fids[0].fid}`"
              accept=".mp4"
              :max-video-duration-sec="30"
              :max-video-size-mb="50"
              video-limit-toast="视频最长30秒，最大50MB"
              :urls="paramData.fids[0].url"
              @onUrls="videoUploaded"
              @upload-state="onVideoUploadState"
            >
            </UploadItem>
            <div class="video-limit-tip">视频最长30秒，最大50MB</div>
            <div v-if="videoMetaHint" class="video-meta-hint">
              {{ videoMetaHint }}
            </div>
          </div>
        </el-form-item>
        <el-form-item label="发送时间">
          <el-radio-group v-model="sendMode">
            <el-radio label="now">立即发送</el-radio>
            <el-radio label="scheduled">定时发送</el-radio>
          </el-radio-group>
          <el-date-picker
            v-if="sendMode === 'scheduled'"
            v-model="timedPublishAt"
            type="datetime"
            placeholder="选择发送时间"
            style="margin-left: 12px; width: 220px"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
    </div>

    <div class="margin-20 save-actions">
      <el-button type="primary" :disabled="isSaveDisabled" @click="clickSave"
        >保存</el-button
      >
    </div>
  </div>
</template>

<script>
/** 运营后台发布动态 — 日志前缀，便于筛选 */
const LOG_TAG_DYNAMIC_PUBLISH = "[DynamicPublish]";
import UploadItem from "../../../../components/UploadItems/UploadItem.vue";

export default {
  components: {
    UploadItem,
  },

  data() {
    const validatePublishUid = (rule, value, callback) => {
      if (value === null || value === undefined || value === "") {
        callback(new Error("请选择发布账号"));
        return;
      }
      callback();
    };
    return {
      loading: false,
      /** 视频文件 HTTP 上传中（选完文件即开始，由 UploadItem 上报） */
      videoUploadRequesting: false,
      selectLoading: false,
      accountSearchMode: "name",
      currentAccountKeyword: "",
      accountOptions: [],
      topicCategories: [],
      topicList: [],
      sendMode: "now",
      timedPublishAt: "",
      lastPickedAccount: null,
      paramData: {
        publishAuthorType: 2,
        publishUid: null,
        categoryId: "",
        topicIds: [],
        topicId: null,
        content: "",
        type: null,
        /** 视频时长（秒），上传后探测得到，用于发布接口 videoDuration */
        videoDuration: 0,
        /** 本地截取首帧并上传得到的封面 URL，用于 videoCover */
        videoCoverUrl: "",
        fids: [{ fid: "", url: "" }],
      },
      formRules: {
        publishUid: [
          {
            required: true,
            message: "请选择发布账号",
            trigger: ["change", "blur"],
          },
          {
            validator: validatePublishUid,
            trigger: ["change", "blur"],
          },
        ],
        content: [
          { required: true, message: "请输入动态内容", trigger: "blur" },
        ],
      },
      /** idle | probing | ready | failed — 与 paramData 同级，便于与上传 loading 联动 */
      videoMetaState: "idle",
      /** 递增令牌：用于丢弃视频元数据的过期异步回调 */
      videoMetaProbeToken: 0,
    };
  },

  mounted() {
    this.queryTopicCategories();
    this.queryBurnerAccount("");
  },

  computed: {
    isSaveDisabled() {
      if (this.loading) {
        return true;
      }
      if (this.paramData.type !== 2) {
        return false;
      }
      const url = this.paramData.fids[0] && this.paramData.fids[0].url;
      if (!url || !String(url).trim()) {
        return false;
      }
      return this.videoMetaState !== "ready";
    },
    videoMetaHint() {
      if (this.paramData.type !== 2) {
        return "";
      }
      const url = this.paramData.fids[0] && this.paramData.fids[0].url;
      if (!url || !String(url).trim()) {
        return "";
      }
      if (this.videoMetaState === "probing") {
        return "正在读取视频信息，读取完成后才可保存";
      }
      if (this.videoMetaState === "failed") {
        return "无法读取视频信息，请删除后重新上传或更换视频";
      }
      if (
        this.videoMetaState === "ready" &&
        Number(this.paramData.videoDuration) >= 0
      ) {
        const coverOk = !!(
          this.paramData.videoCoverUrl &&
          String(this.paramData.videoCoverUrl).trim()
        );
        const coverTip = coverOk
          ? "，封面已上传"
          : "（封面未生成，保存时将暂用视频地址）";
        return `已读取时长 ${this.formatDurationDisplay(
          this.paramData.videoDuration
        )}${coverTip}`;
      }
      return "";
    },
    /** 上传中或读取元数据中时展示整段 loading，避免选完文件后无反馈 */
    videoProcessing() {
      if (this.paramData.type !== 2) {
        return false;
      }
      if (this.videoUploadRequesting) {
        return true;
      }
      const url =
        this.paramData.fids[0] && this.paramData.fids[0].url
          ? String(this.paramData.fids[0].url).trim()
          : "";
      if (!url) {
        return false;
      }
      return this.videoMetaState === "probing";
    },
  },

  watch: {
    "paramData.fids": {
      handler(val) {
        console.log(val);
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    onVideoUploadState(busy) {
      this.videoUploadRequesting = !!busy;
    },
    formatDurationDisplay(seconds) {
      const total = Math.max(0, Math.floor(Number(seconds) || 0));
      const minute = Math.floor(total / 60);
      const second = total % 60;
      return `${String(minute).padStart(2, "0")}:${String(second).padStart(
        2,
        "0"
      )}`;
    },
    isRequestSuccess(errorCode) {
      return errorCode === 10000 || errorCode === 0;
    },
    vestListAccountType(publishAuthorType) {
      const map = { 2: 1, 3: 3, 4: 4 };
      return map[publishAuthorType] != null ? map[publishAuthorType] : 1;
    },
    onPublishAuthorTypeChange() {
      this.paramData.publishUid = null;
      this.accountOptions = [];
      this.lastPickedAccount = null;
      this.currentAccountKeyword = "";
      this.queryBurnerAccount("");
    },
    onAccountSearchModeChange() {
      this.queryBurnerAccount(this.currentAccountKeyword);
    },
    onAccountSelectClear() {
      this.queryBurnerAccount(this.currentAccountKeyword);
    },
    onPublishUserChange(uid) {
      if (uid == null || uid === "") {
        this.lastPickedAccount = null;
      } else {
        const row = this.accountOptions.find((item) => item.uid == uid);
        if (row) {
          this.lastPickedAccount = { uid: row.uid, unid: row.unid };
        }
      }
      this.$nextTick(() => {
        const form = this.$refs.formRef;
        if (form && typeof form.validateField === "function") {
          form.validateField("publishUid");
        }
      });
    },
    onMaterialTypeChange(val) {
      this.videoMetaProbeToken += 1;
      this.paramData.videoDuration = 0;
      this.paramData.videoCoverUrl = "";
      this.videoUploadRequesting = false;
      this.videoMetaState = "idle";
      if (val === 1) {
        this.paramData.fids = [{ fid: "", url: "" }];
      } else if (val === 2) {
        this.paramData.fids = [{ fid: "", url: "" }];
      } else {
        this.paramData.fids = [{ fid: "", url: "" }];
      }
    },
    formatDateTime(value) {
      if (!value) {
        return "";
      }
      const date = new Date(value);
      if (isNaN(date.getTime())) {
        return String(value);
      }
      const yyyy = date.getFullYear();
      const MM = String(date.getMonth() + 1).padStart(2, "0");
      const dd = String(date.getDate()).padStart(2, "0");
      const hh = String(date.getHours()).padStart(2, "0");
      const mm = String(date.getMinutes()).padStart(2, "0");
      const ss = String(date.getSeconds()).padStart(2, "0");
      return `${yyyy}-${MM}-${dd} ${hh}:${mm}:${ss}`;
    },
    queryBurnerAccount(value) {
      const keyword = String(value || "").trim();
      this.currentAccountKeyword = keyword;
      this.selectLoading = true;
      const param = {
        pageNum: 1,
        pageSize: 50,
        accountType: this.vestListAccountType(this.paramData.publishAuthorType),
      };
      if (keyword) {
        if (this.accountSearchMode === "name") {
          param.name = keyword;
        } else {
          const n = Number(keyword);
          param.uid = isNaN(n) ? keyword : n;
        }
      }
      this.$http({
        url: this.$util.domain + "/adminapi/v1/operate/v2/vests/list",
        method: "POST",
        body: JSON.stringify(param),
      })
        .then((res) => {
          const result = (res && (res.body || res.data)) || {};
          const data = result.data || {};
          this.accountOptions = data.list || [];
        })
        .catch(() => {
          this.accountOptions = [];
        })
        .finally(() => {
          this.selectLoading = false;
        });
    },
    queryTopicCategories() {
      this.$http({
        method: "POST",
        url: this.$util.domain + "/adminapi/v2/operate/topic/categories",
      })
        .then((response) => {
          const res = (response && (response.body || response.data)) || {};
          if (this.isRequestSuccess(res.error) && res.data) {
            this.topicCategories = res.data.map((item) => ({
              label: item.name,
              value: String(item.id),
            }));
          } else {
            this.topicCategories = [];
          }
        })
        .catch(() => {
          this.topicCategories = [];
        });
    },
    changeTopicCategory() {
      this.paramData.topicId = null;
      this.topicList = [];
      if (!this.paramData.categoryId) {
        return;
      }
      this.queryTopicList();
    },
    queryTopicList() {
      this.$http({
        method: "POST",
        url: this.$util.domain + "/adminapi/v2/operate/topic/list",
        body: JSON.stringify({
          categoryId: this.paramData.categoryId,
          status: 2,
          keyword: "",
          pageNum: 1,
          pageSize: 10000,
        }),
      })
        .then((response) => {
          const res = (response && (response.body || response.data)) || {};
          if (this.isRequestSuccess(res.error) && res.data && res.data.list) {
            this.topicList = res.data.list.map((item) => ({
              label: item.title,
              value: item.id,
            }));
          } else {
            this.topicList = [];
          }
        })
        .catch(() => {
          this.topicList = [];
        });
    },
    resolveUploadUrl(previewUrl, serverData) {
      if (typeof serverData === "string" && serverData.trim()) {
        return serverData.trim();
      }
      if (
        serverData &&
        typeof serverData === "object" &&
        typeof serverData.url === "string" &&
        serverData.url.trim()
      ) {
        return serverData.url.trim();
      }
      return previewUrl || "";
    },
    /**
     * 根据已上传视频的 URL 拉取 metadata；ok 表示读到合法 duration（含 0 秒极短视频）
     */
    probeVideoMeta(url) {
      return new Promise((resolve) => {
        const u = typeof url === "string" ? url.trim() : "";
        if (!u) {
          resolve({ ok: false, seconds: 0 });
          return;
        }
        const video = document.createElement("video");
        video.preload = "metadata";
        video.muted = true;
        video.playsInline = true;
        let settled = false;
        const finish = (result) => {
          if (settled) {
            return;
          }
          settled = true;
          clearTimeout(timer);
          video.removeAttribute("src");
          video.load();
          resolve(result);
        };
        const timer = setTimeout(() => {
          console.warn(LOG_TAG_DYNAMIC_PUBLISH, "probeVideoMeta timeout", u);
          finish({ ok: false, seconds: 0 });
        }, 20000);
        video.onloadedmetadata = () => {
          const d = video.duration;
          if (!Number.isFinite(d)) {
            if (!video.crossOrigin) {
              video.crossOrigin = "anonymous";
              video.src = u;
              return;
            }
            finish({ ok: false, seconds: 0 });
            return;
          }
          const sec = Math.max(0, Math.round(d));
          finish({ ok: true, seconds: sec });
        };
        video.onerror = () => {
          if (!video.crossOrigin) {
            video.crossOrigin = "anonymous";
            video.src = u;
            return;
          }
          console.warn(LOG_TAG_DYNAMIC_PUBLISH, "probeVideoMeta error", u);
          finish({ ok: false, seconds: 0 });
        };
        video.src = u;
      });
    },
    imageUploaded(url, keys) {
      const finalUrl = this.resolveUploadUrl(url, keys);
      const keyStr = keys != null ? String(keys) : "";
      let index = this.paramData.fids.findIndex((item) => item.fid === keyStr);
      if (index === -1) {
        index = this.paramData.fids.length - 1;
        this.paramData.fids[index].url = finalUrl;
        this.paramData.fids[index].fid = keyStr;
        if (index < 8) {
          this.paramData.fids.push({ fid: "", url: "" });
        }
      } else {
        this.paramData.fids.splice(index, 1);
        const uploadCount = this.paramData.fids.filter(
          (item) => item.url
        ).length;
        if (this.paramData.fids.length < 1 || uploadCount === 8) {
          this.paramData.fids.push({ fid: "", url: "" });
        }
      }
    },
    /**
     * @param {Object} [durationMeta] 由 UploadItem 用本地 File + blob URL 解析的时长，无跨域问题；无则回退远程 URL 探测
     * @param {string} [posterUrl] 本地截取首帧上传得到的封面地址
     */
    videoUploaded(url, keys, durationMeta, posterUrl) {
      const finalUrl = this.resolveUploadUrl(url, keys);
      const coverStr = typeof posterUrl === "string" ? posterUrl.trim() : "";
      this.paramData.videoCoverUrl = coverStr;
      let index = this.paramData.fids.findIndex(
        (item) => item.fid === String(keys)
      );
      if (index === -1) {
        index = this.paramData.fids.length - 1;
        this.paramData.fids[index].url = finalUrl;
        this.paramData.fids[index].fid = `${keys}`;
      } else {
        this.paramData.fids[index].url = "";
        this.paramData.fids[index].fid = "";
      }
      if (finalUrl) {
        const currentProbeToken = ++this.videoMetaProbeToken;
        this.videoMetaState = "probing";
        if (durationMeta && durationMeta.ok === true) {
          if (currentProbeToken !== this.videoMetaProbeToken) {
            return;
          }
          this.paramData.videoDuration = Number(durationMeta.seconds) || 0;
          this.videoMetaState = "ready";
          console.log(
            LOG_TAG_DYNAMIC_PUBLISH,
            "video duration from local file (blob)",
            {
              seconds: this.paramData.videoDuration,
            }
          );
          return;
        }
        this.probeVideoMeta(finalUrl).then(({ ok, seconds }) => {
          if (currentProbeToken !== this.videoMetaProbeToken) {
            return;
          }
          const currentUrl =
            this.paramData.fids[0] && this.paramData.fids[0].url
              ? String(this.paramData.fids[0].url).trim()
              : "";
          if (!currentUrl || currentUrl !== finalUrl) {
            return;
          }
          this.paramData.videoDuration = seconds;
          this.videoMetaState = ok ? "ready" : "failed";
          if (ok) {
            console.log(
              LOG_TAG_DYNAMIC_PUBLISH,
              "video meta ok (remote fallback)",
              {
                seconds,
                url: finalUrl,
              }
            );
          } else {
            console.warn(
              LOG_TAG_DYNAMIC_PUBLISH,
              "video meta failed (remote)",
              finalUrl
            );
          }
        });
      } else {
        this.videoMetaProbeToken += 1;
        this.videoUploadRequesting = false;
        this.paramData.videoDuration = 0;
        this.paramData.videoCoverUrl = "";
        this.videoMetaState = "idle";
      }
    },
    buildPublishBody() {
      const userId = this.paramData.publishUid;
      const account = this.getSelectedAccount();
      const unid = account && account.unid != null ? Number(account.unid) : 0;
      const content = String(this.paramData.content || "").trim();
      const authorType = Number(this.paramData.publishAuthorType);
      const body = {
        userId: userId != null ? Number(userId) : 0,
        unid,
        content,
        authorType,
      };
      if (this.paramData.topicIds && this.paramData.topicIds.length) {
        body.topicIds = this.paramData.topicIds;
      }
      if (this.sendMode === "scheduled" && this.timedPublishAt) {
        body.timedPublish = this.formatDateTime(this.timedPublishAt);
      }
      const t = this.paramData.type;
      if (t === 1) {
        const urls = this.paramData.fids;
        if (urls.length) {
          body.imageList = urls.slice(0, 9);
        }
      } else if (t === 2) {
        const v = this.paramData.fids[0];
        const videoUrl = v && v.url ? String(v.url).trim() : "";
        if (videoUrl) {
          body.videoUrl = videoUrl;
          const cover = (this.paramData.videoCoverUrl || "").trim();
          body.videoCover = cover || videoUrl;
          if (!cover) {
            console.warn(
              LOG_TAG_DYNAMIC_PUBLISH,
              "videoCover fallback to videoUrl (poster upload failed or empty)"
            );
          }
          body.videoDuration = Math.max(
            0,
            Math.floor(Number(this.paramData.videoDuration) || 0)
          );
        }
      }
      return body;
    },
    submitPublish() {
      const selectedAccount = this.getSelectedAccount();
      if (!selectedAccount) {
        this.$message.warning("请选择发布账号");
        return;
      }
      const t = this.paramData.type;
      if (t === 2) {
        const v = this.paramData.fids[0];
        const videoUrl = v && v.url ? String(v.url).trim() : "";
        if (videoUrl && this.videoMetaState !== "ready") {
          if (this.videoMetaState === "probing") {
            this.$message.warning("正在读取视频信息，请稍候再保存");
          } else {
            this.$message.warning("视频信息读取失败，请删除后重新上传");
          }
          return;
        }
      }
      const payload = this.buildPublishBody();
      console.log(LOG_TAG_DYNAMIC_PUBLISH, "publish submit", {
        authorType: payload.authorType,
        hasTopics: !!(payload.topicIds && payload.topicIds.length),
        hasImages: !!(payload.images && payload.images.length),
        hasVideo: !!payload.videoUrl,
        videoDuration: payload.videoDuration,
        videoCover: payload.videoCover,
        timed: !!payload.timedPublish,
      });
      this.loading = true;
      this.$http({
        method: "POST",
        url: this.$util.domain + "/adminapi/v70300/community/dynamic/publish",
        body: JSON.stringify(payload),
      })
        .then((res) => {
          const result = (res && (res.body || res.data)) || {};
          if (this.isRequestSuccess(result.error)) {
            this.$message.success("发布成功");
            try {
              /* 与 DynamicManage.vue SESSION_KEY_DELAY_LIST_REFRESH 一致 */
              sessionStorage.setItem("dynamicManage_delayListRefresh", "1");
            } catch (e) {
              /* ignore */
            }
            this.$router.go(-1);
          } else {
            this.$message.error(result.message || "发布失败");
          }
        })
        .catch(() => {
          this.$message.error("发布失败");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    clickSave() {
      this.$refs.formRef.validate((valid) => {
        if (!valid) {
          return;
        }
        const selectedAccount = this.getSelectedAccount();
        if (!selectedAccount) {
          this.$message.warning("请选择发布账号");
          return;
        }
        if (this.sendMode === "scheduled" && !this.timedPublishAt) {
          this.$message.warning("请选择发送时间");
          return;
        }
        this.submitPublish();
      });
    },
    getSelectedAccount() {
      const userId = this.paramData.publishUid;
      if (userId === null || userId === undefined || userId === "") {
        return null;
      }
      return (
        this.accountOptions.find((item) => item.uid == userId) ||
        (this.lastPickedAccount && this.lastPickedAccount.uid == userId
          ? this.lastPickedAccount
          : null)
      );
    },
  },
};
</script>

<style scoped>
.back {
  float: right;
}

.form-wrapper {
  max-width: 900px;
}

.form-item-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: nowrap;
  gap: 10px;
  width: 100%;
}

.form-item-row__col {
  min-width: 0;
}

.form-item-row__col--author {
  flex: 0 0 132px;
  width: 132px;
}

.form-item-row__col--mode {
  flex: 0 0 118px;
  width: 118px;
}

.form-item-row__col--grow {
  flex: 1 1 auto;
  min-width: 220px;
}

.form-item-row__col--half {
  flex: 1 1 50%;
  min-width: 0;
}

.image-list {
  display: flex;
  overflow: auto;
  gap: 10px;
  flex-wrap: wrap;
}

.image-bezel {
  width: 150px;
  min-width: 150px;
}

.account-option {
  display: flex;
  align-items: center;
}

.account-option-avatar {
  width: 22px;
  height: 22px;
  margin-right: 8px;
  object-fit: cover;
  border-radius: 2px;
}

.margin-20 {
  margin: 20px;
}

.save-actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.video-material-wrap {
  position: relative;
  min-height: 208px;
  padding-bottom: 10px;
}

.video-meta-hint {
  margin-top: 8px;
  font-size: 13px;
  color: #909399;
  line-height: 1.4;
}

.video-limit-tip {
  margin-top: 8px;
  font-size: 13px;
  color: #f56c6c;
  line-height: 1.4;
}

.flex-row {
  display: flex;
}
</style>



// WEBPACK FOOTER //
// DynamicDetail.vue?1213fce6